/* File : src/routes/index.js */
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import { EventProvider } from '../contexts/EventContext';

// Pages invités
import HomePage from '../pages/GuestPages/HomePage';
import CitySelectionPage from '../pages/GuestPages/CitySelectionPage';
import EventPage from '../pages/GuestPages/EventPage';
import TicketTypeSelection from '../pages/GuestPages/TicketTypeSelection';
import PaymentPage from '../pages/GuestPages/PaymentPage';
import RegistrationPage from '../pages/GuestPages/RegistrationPage';
import TicketPage from '../pages/GuestPages/TicketPage';
import RetrieveTicketPage from '../pages/GuestPages/RetrieveTicketPage';

// Pages administrateur
import StatsPage from '../components/StatsPage';
import PaymentAnalysisPage from '../pages/admin/PaymentAnalysisPage'; // ✅ AJOUTÉ

// Page du scanner - accès direct
import ScannerPage from '../pages/ScannerPage/ScannerPage';

// Composant pour extraire l'ID d'événement de l'URL (legacy support)
const EventRedirect = () => {
  const navigate = useNavigate();
  
  // Rediriger directement vers la page d'accueil - l'événement sera récupéré automatiquement
  React.useEffect(() => {
    navigate('/');
  }, [navigate]);
  
  return <div>Redirection...</div>;
};

// Wrapper pour les pages qui nécessitent le contexte d'événement
const EventContextWrapper = ({ children }) => (
  <EventProvider>
    {children}
  </EventProvider>
);

const AppRoutes = () => {
  return (
    <Router basename="/brightnight">
      <Routes>
        {/* ========================================
            ROUTES PUBLIQUES - INVITÉS
            ======================================== */}
        
        {/* Route d'accueil - vérification d'âge */}
        <Route path="/" element={<HomePage />} />
        
        {/* Route de sélection de ville (conservée pour rétrocompatibilité) */}
        <Route path="/city-selection" element={
          <EventContextWrapper>
            <CitySelectionPage />
          </EventContextWrapper>
        } />
        
        {/* Routes après vérification d'âge, avec contexte d'événement */}
        <Route path="/event" element={
          <EventContextWrapper>
            <EventPage />
          </EventContextWrapper>
        } />
        
        {/* Route de sélection du type de ticket */}
        <Route path="/ticket-selection" element={
          <EventContextWrapper>
            <TicketTypeSelection />
          </EventContextWrapper>
        } />
        
        {/* Route de paiement */}
        <Route path="/payment" element={
          <EventContextWrapper>
            <PaymentPage />
          </EventContextWrapper>
        } />
        
        <Route path="/register" element={
          <EventContextWrapper>
            <RegistrationPage />
          </EventContextWrapper>
        } />
        
        <Route path="/ticket/:phone" element={
          <EventContextWrapper>
            <TicketPage />
          </EventContextWrapper>
        } />
        
        {/* Page de récupération de ticket */}
        <Route path="/retrieve-ticket" element={
          <EventContextWrapper>
            <RetrieveTicketPage />
          </EventContextWrapper>
        } />
        
        {/* Support des anciennes URLs avec ID d'événement (redirection) */}
        <Route path="/events/:eventId" element={<EventRedirect />} />
        
        {/* ========================================
            ROUTES ADMINISTRATEUR (URLs obscures)
            ⚠️ Protéger ces routes en production
            ======================================== */}
        
        {/* Dashboard statistiques créateurs */}
        <Route path="/stats-bn2025xyz" element={<StatsPage />} />
        
        {/* ✅ NOUVEAU : Dashboard analyse des paiements */}
        <Route path="/admin-payments-bn2025" element={<PaymentAnalysisPage />} />
        
        {/* ========================================
            ROUTES FONCTIONNELLES
            ======================================== */}
        
        {/* Scanner de tickets */}
        <Route path="/scanner" element={<ScannerPage />} />
        
        {/* Redirection par défaut */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;